(function () {
  "use strict";

  var CONFIG = {
    endpoint: "https://go.magie-schmuck.de/sr/batch",
    rrwebUrl: "https://cdn.jsdelivr.net/npm/rrweb@1.1.3/dist/rrweb.min.js",
    sampleRate: 1,
    flushEveryMs: 5000,
    flushEveryEvents: 80,
    maxEventsPerBatch: 300,
    requireConsent: true,
    debug: false
  };

  var blockedPathPattern = /\/(account|accounts|checkout|checkouts|challenge)(\/|$)/i;
  var currentPath = window.location.pathname || "/";
  if (blockedPathPattern.test(currentPath)) return;

  // Render-capable crawlers execute storefront JavaScript and otherwise pollute
  // the replay funnel with catalog scans rather than customer behavior.
  function isAutomatedAgent() {
    var userAgent = String(navigator.userAgent || "");
    return /\b(bot|crawler|spider|slurp|bingpreview|storebot|claudebot|gptbot|baiduspider)\b|meta-externalads/i.test(userAgent);
  }

  if (isAutomatedAgent()) return;

  var state = {
    started: false,
    stopRecording: null,
    events: [],
    markers: [],
    sessionId: getSessionId(),
    batchIndex: getBatchIndex(),
    landingUrl: sessionStorage.getItem("magie_sr_landing_url") || window.location.href,
    attribution: null,
    consentState: "unknown",
    lastFormSubmitAt: {}
  };
  sessionStorage.setItem("magie_sr_landing_url", state.landingUrl);

  function log() {
    if (CONFIG.debug && window.console) console.log.apply(console, arguments);
  }

  function getSessionId() {
    var existing = sessionStorage.getItem("magie_sr_session_id");
    if (existing) return existing;
    var random = "";
    if (window.crypto && window.crypto.getRandomValues) {
      var bytes = new Uint8Array(16);
      window.crypto.getRandomValues(bytes);
      random = Array.prototype.map.call(bytes, function (byte) {
        return byte.toString(16).padStart(2, "0");
      }).join("");
    } else {
      random = String(Date.now()) + String(Math.random()).slice(2);
    }
    var sessionId = "sr_" + random;
    sessionStorage.setItem("magie_sr_session_id", sessionId);
    return sessionId;
  }

  function getBatchIndex() {
    var existing = Number(sessionStorage.getItem("magie_sr_batch_index"));
    if (Number.isSafeInteger(existing) && existing > 0) return existing;
    var initial = Date.now();
    sessionStorage.setItem("magie_sr_batch_index", String(initial));
    return initial;
  }

  function loadScript(src, onload) {
    var script = document.createElement("script");
    script.src = src;
    script.async = true;
    script.onload = onload;
    script.onerror = function () {
      log("magie session replay: failed to load rrweb");
    };
    document.head.appendChild(script);
  }

  function consentAllowsRecording() {
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    if (!privacy) {
      state.consentState = "privacy_api_unavailable";
      return !CONFIG.requireConsent;
    }
    if (typeof privacy.analyticsProcessingAllowed === "function") {
      var allowed = Boolean(privacy.analyticsProcessingAllowed());
      state.consentState = allowed ? "analytics_allowed" : "analytics_denied";
      return allowed;
    }
    state.consentState = "analytics_method_unavailable";
    return !CONFIG.requireConsent;
  }

  function safeUrl(value) {
    return String(value || "").slice(0, 500);
  }

  function parseUrl(value) {
    try {
      return new URL(value, window.location.origin);
    } catch (err) {
      return null;
    }
  }

  function queryParam(url, key) {
    return url && url.searchParams ? String(url.searchParams.get(key) || "").slice(0, 160) : "";
  }

  function classifySource(landingUrl, referrer) {
    var url = parseUrl(landingUrl);
    var utmSource = queryParam(url, "utm_source");
    var utmMedium = queryParam(url, "utm_medium");
    var ref = parseUrl(referrer);
    var host = ref && ref.hostname ? ref.hostname.replace(/^www\./, "") : "";
    if (utmSource || utmMedium) return [utmSource, utmMedium].filter(Boolean).join(" / ");
    if (!host || host === window.location.hostname.replace(/^www\./, "")) return "direct_or_unknown";
    if (/google|bing|duckduckgo|yahoo|ecosia/.test(host)) return "organic_search";
    if (/instagram|facebook|pinterest|tiktok|reddit/.test(host)) return "organic_social";
    return "referral:" + host;
  }

  function readAttribution() {
    var stored = {};
    try {
      stored = JSON.parse(sessionStorage.getItem("magie_attribution_v1") || "{}");
    } catch (err) {
      stored = {};
    }
    var landing = stored.landing_url || state.landingUrl || window.location.href;
    var referrer = stored.referrer || document.referrer || "";
    var landingParsed = parseUrl(landing);
    var attribution = {
      version: "2026-07-14",
      session_id: state.sessionId,
      first_seen_at: stored.first_seen_at || new Date().toISOString(),
      landing_url: safeUrl(landing),
      referrer: safeUrl(referrer),
      source_guess: stored.source_guess || classifySource(landing, referrer),
      utm_source: stored.utm_source || queryParam(landingParsed, "utm_source"),
      utm_medium: stored.utm_medium || queryParam(landingParsed, "utm_medium"),
      utm_campaign: stored.utm_campaign || queryParam(landingParsed, "utm_campaign"),
      utm_content: stored.utm_content || queryParam(landingParsed, "utm_content"),
      internal_campaign: stored.internal_campaign || "",
      internal_content: stored.internal_content || "",
      first_product: stored.first_product || "",
      last_product: stored.last_product || "",
      last_action: stored.last_action || "session_start"
    };
    sessionStorage.setItem("magie_attribution_v1", JSON.stringify(attribution));
    return attribution;
  }

  function updateAttribution(updates) {
    state.attribution = Object.assign(readAttribution(), updates || {});
    sessionStorage.setItem("magie_attribution_v1", JSON.stringify(state.attribution));
    syncCartAttribution(false);
  }

  function cartAttributesPayload() {
    var attribution = state.attribution || readAttribution();
    var attrs = {
      "magie_sr_session_id": attribution.session_id,
      "magie_source_guess": attribution.source_guess,
      "magie_landing_url": attribution.landing_url,
      "magie_referrer": attribution.referrer,
      "magie_utm_source": attribution.utm_source,
      "magie_utm_medium": attribution.utm_medium,
      "magie_utm_campaign": attribution.utm_campaign,
      "magie_utm_content": attribution.utm_content,
      "magie_internal_campaign": attribution.internal_campaign,
      "magie_internal_content": attribution.internal_content,
      "magie_first_product": attribution.first_product,
      "magie_last_product": attribution.last_product,
      "magie_last_action": attribution.last_action
    };
    return Object.keys(attrs).reduce(function (result, key) {
      if (attrs[key]) result[key] = String(attrs[key]).slice(0, 500);
      return result;
    }, {});
  }

  function syncCartAttribution(keepalive) {
    if (!state.started || !consentAllowsRecording()) return;
    var attrs = cartAttributesPayload();
    if (!Object.keys(attrs).length) return;
    var signature = JSON.stringify(attrs);
    if (!keepalive && state.lastCartAttributionSignature === signature) return;
    state.lastCartAttributionSignature = signature;
    fetch("/cart/update.js", {
      method: "POST",
      credentials: "same-origin",
      keepalive: Boolean(keepalive),
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      body: JSON.stringify({ attributes: attrs })
    }).catch(function (err) {
      log("magie attribution cart sync failed", err);
    });
  }

  function ensureCartAttributeInputs(form) {
    if (!form || !form.matches || !form.matches('form[action*="/cart"]')) return;
    var attrs = cartAttributesPayload();
    Object.keys(attrs).forEach(function (key) {
      var name = "attributes[" + key + "]";
      var input = form.querySelector('input[name="' + name + '"]');
      if (!input) {
        input = document.createElement("input");
        input.type = "hidden";
        input.name = name;
        input.setAttribute("data-magie-attribution-input", "true");
        form.appendChild(input);
      }
      input.value = attrs[key];
    });
  }

  function installCartFormBridge() {
    Array.prototype.forEach.call(document.querySelectorAll('form[action*="/cart"]'), ensureCartAttributeInputs);
    document.addEventListener("submit", function (event) {
      var form = event.target;
      ensureCartAttributeInputs(form);
      syncCartAttribution(true);
    }, true);
  }

  function waitForConsent(callback) {
    var attempts = 0;

    function check() {
      attempts += 1;
      if (consentAllowsRecording()) {
        callback();
        return;
      }
      if (attempts < 20 && state.consentState === "privacy_api_unavailable") {
        window.setTimeout(check, 250);
      }
    }

    check();

    document.addEventListener("visitorConsentCollected", function () {
      if (!state.started && consentAllowsRecording()) callback();
    });
  }

  function getContext() {
    return {
      url: window.location.href,
      landing_url: state.landingUrl,
      referrer: document.referrer || "",
      locale: document.documentElement.getAttribute("lang") || navigator.language || "",
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone || "",
      consent_state: state.consentState,
      viewport: {
        width: window.innerWidth || 0,
        height: window.innerHeight || 0,
        dpr: window.devicePixelRatio || 1
      },
      shop: window.Shopify && window.Shopify.shop,
      theme: window.theme && window.theme.settings ? window.theme.settings.themeName : "unknown"
    };
  }

  function enqueueMarker(type, details) {
    if (type) updateAttribution({ last_action: type });
    state.markers.push({
      type: type,
      ts: Date.now(),
      details: details || {}
    });
    if (state.markers.length >= 10) flush(false);
  }

  function compactElementInfo(el) {
    if (!el || !el.tagName) return {};
    var getAttr = function (name) {
      return el.getAttribute ? (el.getAttribute(name) || "") : "";
    };
    return {
      tag: String(el.tagName).toLowerCase(),
      id: String(getAttr("id")).slice(0, 120),
      classes: String(getAttr("class")).slice(0, 160),
      role: String(getAttr("role")).slice(0, 80),
      name: String(getAttr("name")).slice(0, 120),
      href: el.href ? String(el.href).slice(0, 500) : "",
      text: String(el.innerText || el.textContent || "").replace(/\s+/g, " ").trim().slice(0, 120)
    };
  }

  function productContext() {
    var path = window.location.pathname || "";
    if (path.indexOf("/products/") === -1) return null;
    var canonical = document.querySelector("link[rel='canonical']");
    var title = document.querySelector("h1, .product-single__title, [data-product-title]");
    return {
      path: path,
      handle: path.split("/products/")[1].split(/[/?#]/)[0],
      title: String(title && (title.innerText || title.textContent) || document.title || "").replace(/\s+/g, " ").trim().slice(0, 160),
      canonical: canonical && canonical.href ? String(canonical.href).slice(0, 500) : window.location.href
    };
  }

  function markProductView() {
    var info = productContext();
    if (!info) return;
    if (state.lastProductView === info.path) return;
    state.lastProductView = info.path;
    updateAttribution({
      first_product: (state.attribution && state.attribution.first_product) || info.handle,
      last_product: info.handle,
      last_action: "product_view"
    });
    enqueueMarker("product_view", info);
  }

  function installBusinessMarkers() {
    markProductView();

    var formFeedback = document.querySelector("form[action*='/contact'] .note--success, form[action*='/contact'] .errors");
    if (formFeedback) {
      enqueueMarker(
        formFeedback.classList.contains("note--success") ? "form_submit_success" : "form_submit_error",
        compactElementInfo(formFeedback)
      );
    }

    document.addEventListener("click", function (event) {
      var galleryTarget = event.target && event.target.closest
        ? event.target.closest("[data-product-thumb], .product__thumb-arrow, .product__photo-dots")
        : null;
      if (galleryTarget) {
        enqueueMarker("product_gallery_interaction", compactElementInfo(galleryTarget));
      }

      var target = event.target && event.target.closest ? event.target.closest("a,button,[role='button'],input[type='submit']") : null;
      if (!target) return;
      var info = compactElementInfo(target);
      var trackedUrl = target.href ? parseUrl(target.href) : null;
      var internalCampaign = trackedUrl && trackedUrl.origin === window.location.origin
        ? queryParam(trackedUrl, "utm_campaign")
        : "";
      var internalMedium = trackedUrl ? queryParam(trackedUrl, "utm_medium") : "";
      var guideCta = target.getAttribute ? target.getAttribute("data-magie-guide-cta") : "";
      if (internalCampaign && internalMedium === "internal") {
        var internalContent = queryParam(trackedUrl, "utm_content");
        updateAttribution({
          internal_campaign: internalCampaign,
          internal_content: internalContent,
          last_action: guideCta ? "guide_" + guideCta.replace(/-/g, "_") + "_click" : "internal_campaign_click"
        });
        info.internal_campaign = internalCampaign;
        info.internal_content = internalContent;
        if (guideCta) enqueueMarker("guide_" + guideCta.replace(/-/g, "_") + "_click", info);
      }
      var label = (info.text + " " + info.classes + " " + info.href).toLowerCase();
      if (label.indexOf("add-to-cart") !== -1 || target.hasAttribute("data-add-to-cart")) {
        syncCartAttribution(false);
        enqueueMarker("add_to_cart_click", info);
      } else if (label.indexOf("checkout") !== -1 || target.name === "checkout") {
        syncCartAttribution(true);
        enqueueMarker("checkout_click", info);
      } else if (label.indexOf("cart") !== -1 || label.indexOf("warenkorb") !== -1) {
        enqueueMarker("cart_click", info);
      }
    }, true);

    document.addEventListener("change", function (event) {
      var target = event.target;
      if (!target || !target.matches || !target.matches("[data-variant-input]")) return;
      var info = compactElementInfo(target);
      info.value = String(target.value || "").slice(0, 120);
      enqueueMarker("variant_selection", info);
    }, true);

    // The theme emits this only after Shopify's cart/add endpoint accepts the
    // item. Keep it separate from the click marker so keyboard, sticky-CTA,
    // and scripted product-form paths still produce a definitive intent signal.
    document.addEventListener("ajaxProduct:added", function (event) {
      var detail = event.detail || {};
      var product = detail.product || {};
      syncCartAttribution(false);
      enqueueMarker("add_to_cart_success", {
        product_id: String(product.product_id || "").slice(0, 80),
        variant_id: String(product.variant_id || product.id || "").slice(0, 80),
        quantity: Number(product.quantity || 1)
      });
    });

    document.addEventListener("submit", function (event) {
      var form = event.target;
      var info = compactElementInfo(form);
      var key = info.id || info.name || info.action || "anonymous_form";
      var submittedAt = Date.now();
      var previousSubmitAt = Number(state.lastFormSubmitAt[key] || 0);
      state.lastFormSubmitAt[key] = submittedAt;

      enqueueMarker(
        previousSubmitAt && submittedAt - previousSubmitAt < 15000 ? "form_submit_repeat" : "form_submit",
        info
      );

      window.setTimeout(function () {
        if (!document.documentElement.contains(form)) return;
        if (state.lastFormSubmitAt[key] !== submittedAt) return;
        if (form.querySelector(".note--success, .errors")) return;
        enqueueMarker("form_submit_unconfirmed", info);
      }, 12000);
    }, true);

    [
      "cart_line_item_rendered",
      "checkout_cta_visible",
      "cart_drawer_opened",
      "cart_drawer_failed"
    ].forEach(function (name) {
      document.addEventListener("magie:" + name, function (event) {
        enqueueMarker(name, event.detail || {});
      });
    });

    document.addEventListener("visibilitychange", function () {
      enqueueMarker("visibility_" + document.visibilityState, { url: window.location.href });
      if (document.visibilityState === "hidden") flush(true);
    });

    window.addEventListener("popstate", function () {
      enqueueMarker("history_popstate", { url: window.location.href });
      window.setTimeout(markProductView, 50);
    });

    var originalPushState = window.history && window.history.pushState;
    var originalReplaceState = window.history && window.history.replaceState;
    if (originalPushState) {
      window.history.pushState = function () {
        var result = originalPushState.apply(this, arguments);
        window.setTimeout(markProductView, 50);
        return result;
      };
    }
    if (originalReplaceState) {
      window.history.replaceState = function () {
        var result = originalReplaceState.apply(this, arguments);
        window.setTimeout(markProductView, 50);
        return result;
      };
    }
  }

  function sendPayload(payload, keepalive) {
    var body = JSON.stringify(payload);
    if (keepalive && navigator.sendBeacon) {
      try {
        var blob = new Blob([body], { type: "application/json" });
        if (navigator.sendBeacon(CONFIG.endpoint, blob)) return;
      } catch (err) {
        log("magie session replay beacon failed", err);
      }
    }
    fetch(CONFIG.endpoint, {
      method: "POST",
      mode: "cors",
      credentials: "omit",
      keepalive: Boolean(keepalive),
      headers: { "Content-Type": "application/json" },
      body: body
    }).catch(function (err) {
      log("magie session replay post failed", err);
    });
  }

  function flush(keepalive) {
    if (!state.events.length && !state.markers.length) return;
    var events = state.events.splice(0, CONFIG.maxEventsPerBatch);
    var markers = state.markers.splice(0, 100);
    var batchIndex = state.batchIndex++;
    sessionStorage.setItem("magie_sr_batch_index", String(state.batchIndex));
    sendPayload({
      session_id: state.sessionId,
      batch_index: batchIndex,
      url: window.location.href,
      landing_url: state.landingUrl,
      events: events,
      markers: markers,
      context: getContext()
    }, keepalive);
  }

  function startRecorder() {
    if (state.started) return;
    if (Math.random() > CONFIG.sampleRate) return;
    state.started = true;
    state.attribution = readAttribution();
    syncCartAttribution(false);
    // Attribution and commerce markers must not depend on the external rrweb
    // bundle. A slow or unavailable CDN must not create a window in which a
    // fast shopper can add to cart or start checkout before these hooks exist.
    installBusinessMarkers();
    installCartFormBridge();
    enqueueMarker("session_start", { path: window.location.pathname });
    window.setInterval(function () { flush(false); }, CONFIG.flushEveryMs);
    window.addEventListener("pagehide", function () { flush(true); });
    window.addEventListener("beforeunload", function () { flush(true); });
    loadScript(CONFIG.rrwebUrl, function () {
      if (!window.rrweb || typeof window.rrweb.record !== "function") return;
      state.stopRecording = window.rrweb.record({
        emit: function (event) {
          state.events.push(event);
          if (state.events.length >= CONFIG.flushEveryEvents) flush(false);
        },
        maskAllInputs: true,
        maskInputOptions: {
          color: false,
          date: true,
          "datetime-local": true,
          email: true,
          month: true,
          number: true,
          password: true,
          radio: false,
          range: false,
          search: true,
          select: false,
          tel: true,
          text: true,
          textarea: true,
          time: true,
          url: true,
          week: true
        },
        blockClass: "magie-sr-block",
        maskTextClass: "magie-sr-mask",
        collectFonts: false,
        recordCanvas: false,
        sampling: {
          mousemove: 80,
          mouseInteraction: true,
          scroll: 80,
          media: 500,
          input: "last"
        }
      });
    });
  }

  waitForConsent(startRecorder);
})();
